
document.querySelectorAll('video img').forEach(img => {
	if (!img.hasAttribute('alt')) {
		img.setAttribute('alt', '');
	}
});

function fixHeadingHierarchy() {
	const headings = [...document.querySelectorAll('[role="heading"]')];
	let lastLevel = 1;
  
	headings.forEach(el => {
	  const current = parseInt(el.getAttribute('aria-level')) || lastLevel;
	  
	  // Don't allow jumping more than one level down
	  const corrected = Math.min(current, lastLevel + 1);
	  el.setAttribute('aria-level', corrected);
	  lastLevel = corrected;
	});
  }
  
  // Call after everything has initialised
  document.addEventListener('DOMContentLoaded', fixHeadingHierarchy);



// opening sequence
const openingSequence = document.querySelector('.opening_sequence');
if (openingSequence) {
	const videos = document.querySelectorAll('video');
	videos.forEach(video => {
		video.pause();
		video.currentTime = 0;
	});
	setTimeout(() => {
		const videos = document.querySelectorAll('video');
		videos.forEach(video => {
			video.play().catch(() => {});
		});
	}, 2700);

	document.body.classList.add('no-scroll');
	openingInner = openingSequence.querySelector('.opening_sequence-inner');
	const mainLogo = document.querySelector('.main_index-logo');
	// mainLogo.style.opacity = 0;
	mainLogo.style.transform = 'translateY(130%)';
	const opening = gsap.timeline({paused: true});
	opening.to(openingInner, {
		opacity: 1,
		delay: 0.3,
		duration: 1,
		ease: "power2.inOut"
	}).to(openingSequence, {
		height: 0,
		delay: 1.2,
		duration: 1.5,
		ease: "power2.inOut"
	}).to(openingInner, {
		opacity: 0,
		delay: 0.3,
		duration: 0.6,
		width: '20%',
		height: '20%',
		ease: "power2.inOut"
	}, '<').to(mainLogo, {
		// opacity: 1,
		transform: 'translateY(0)',
		delay: 1,
		duration: 1,
		ease: "power2.inOut"
	}, '<')
		.eventCallback('onComplete', function() {
			document.body.classList.remove('no-scroll');
		});

	opening.play();
}

const lenis = new Lenis();
lenis.on('scroll', ScrollTrigger.update);
gsap.ticker.add((time) => {
  lenis.raf(time * 1500); // Convert time from seconds to milliseconds
});
gsap.ticker.lagSmoothing(0);

// Para animation
window.addEventListener('load', () => {
	// enter view
	function enterViewInit() {
		if (window.enterView) {
		enterView({
			selector: ".enter",
			enter: function (el) {
			el.classList.add("entered");
			},
			offset: 0.1, // 15% from bottom of viewport
			once: false, // animate every time it enters
		});
		}
	}
	enterViewInit();

	const splitHeadingLevels = { fxxl: 1, fh1: 1, fh2: 2, fh3: 3, fh4: 4, fh5: 5 };
	const splitHeadingClasses = [
		'text_section-heading',
		'text_media-heading',
		'faqs_section-heading',
		'product-main-content-inner-title',
		'featured-events-item-content-title',
		'event_section-inner-content-data-heading',
		'reservations_section-content-title',
		'socials_section-heading-title',
		'two_col_content-item-heading',
		'error-body',
		'footer-icons-header'
	];
	const splitBodyClasses = [
		'text_section-body',
		'text_media-body',
		'pdescription',
		'two_col_content-item-body',
		'two_col_content-item-further_body',
		'featured-events-item-content-body',
		'event_section-inner-content-data-body',
		'footer-inital-hours-hours'
	];

	function getSplitHeadingLevel(el) {
		const nodes = [el];
		if (el.parentElement) nodes.push(el.parentElement);
		for (const node of nodes) {
			for (const cls of node.classList) {
				if (splitHeadingLevels[cls]) return splitHeadingLevels[cls];
			}
		}
		if (el.classList.contains('ptitle')) return 3;
		if (el.classList.contains('event_section-inner-content-data-sub_heading')) return 3;
		if (splitHeadingClasses.some((cls) => el.classList.contains(cls))) return 2;
		return null;
	}

	function isSplitBodyText(el) {
		return splitBodyClasses.some((cls) => el.classList.contains(cls))
			|| ((el.classList.contains('fp1') || el.classList.contains('fp2'))
				&& !el.classList.contains('featured-events-item-content-title')
				&& !getSplitHeadingLevel(el));
	}

	function isDecorativeSplit(el) {
		return (el.textContent || '').trim().length <= 1;
	}

	function ensureSplitDiv(el) {
		if (el.tagName.toLowerCase() === 'p') {
			const div = document.createElement('div');
			[...el.attributes].forEach(({ name, value }) => div.setAttribute(name, value));
			div.innerHTML = el.innerHTML;
			el.replaceWith(div);
			return div;
		}
		return el;
	}

	function prepareSplitAccessibility(splitEl) {
		if (isDecorativeSplit(splitEl)) {
			splitEl.setAttribute('aria-hidden', 'true');
			return { element: splitEl, aria: 'none' };
		}

		let el = ensureSplitDiv(splitEl);
		const tag = el.tagName.toLowerCase();

		if (['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'a', 'button'].includes(tag)) {
			return { element: el, aria: 'auto' };
		}

		const headingLevel = getSplitHeadingLevel(el);

		if (headingLevel !== null && !isSplitBodyText(el)) {
			if (!el.hasAttribute('role')) {
				el.setAttribute('role', 'heading');
				el.setAttribute('aria-level', String(headingLevel));
			}
			return { element: el, aria: 'auto' };
		}

		if (isSplitBodyText(el)) {
			if (!el.hasAttribute('role')) {
				el.setAttribute('role', 'text');
			}
			return { element: el, aria: 'auto' };
		}

		if ((tag === 'div' || tag === 'span') && !el.hasAttribute('role')) {
			el.setAttribute('role', 'heading');
			el.setAttribute('aria-level', '2');
		}

		return { element: el, aria: 'auto' };
	}

	// GSAP/ScrollTrigger + SplitText animation for .split elements, initially hidden until scrolled in
	document.querySelectorAll('.split-container').forEach((el) => {
		// Split lines and words
		el.querySelectorAll('.split').forEach((splitEl) => {
			const { element, aria } = prepareSplitAccessibility(splitEl);
			const split = SplitText.create(element, {
				type: "lines, words",
				mask: "lines",
				autoSplit: true,
				aria
			});
			// Hide all words initially
			gsap.set(element, {opacity: 1});
			gsap.set(split.words, { autoAlpha: 0, y: 100 });
			// Animate in on scroll into view
			ScrollTrigger.create({
				trigger: el,
				start: "top 80%", // 20% into viewport
				once: false,
				onEnter: () => {
				gsap.to(split.words, {
					duration: 1,
					y: 0,
					autoAlpha: 1,
					stagger: 0.01,
					ease: "power3.out"
				});
				}
			});
		});
	});

	const paraAspects = gsap.utils.toArray(".aspectholder");
	if (paraAspects != null) {
	paraAspects.forEach(function (container) {
		let large = container.querySelector(".para-lg");
		let reg = container.querySelector("para");
		if (large != null) {
			gsap.to(large, {
				y: "50%",
				scale: 1.4,
				ease: "none",
				scrollTrigger: {
				start: "bottom " + large.offsetHeight,
				end: "bottom top",
				trigger: container,
				scrub: true,
				pin: false,
				invalidateOnRefresh: true,
			},
		});
		}
		if (reg != null) {
			gsap.to(reg, {
				y: "100%",
				// opacity: 0,
				scale: 1.4,
				ease: "none",
				scrollTrigger: {
				start: "bottom bottom",
				end: "bottom top",
				trigger: container,
				scrub: true,
				pin: false,
				invalidateOnRefresh: true,
				markers: true,
			},
			});
		}
	});
	}

	// Adjust header theme and bg on scroll based on section, with correct 400px-from-top logic

	const header = document.querySelector('#shopify-section-header');
	let lastHeaderTheme = null;

	// Determine the scroll threshold used for background color
	function getBgScrollThreshold() {
		// Use 100vh on homepage, else 400
		if (window.location.pathname === '/' || window.location.pathname === '/index.html') {
			return window.innerHeight;
		}
		return 50;
	}

	// Section whose content sits under the fixed header (not when its bottom enters the viewport)
	function getHeaderOverlapSection() {
		if (!header) return null;
		const headerBottom = header.getBoundingClientRect().bottom;
		const sections = Array.from(document.querySelectorAll('section'));
		let activeSection = null;
		let maxTop = -Infinity;
		sections.forEach(section => {
			const rect = section.getBoundingClientRect();
			if (rect.top < headerBottom && rect.bottom > headerBottom && rect.top > maxTop) {
				activeSection = section;
				maxTop = rect.top;
			}
		});
		return activeSection;
	}

	function getSectionBg(section) {
		if (!section) return "transparent";
		let sectionBg = window.getComputedStyle(section).getPropertyValue('background-color');
		if ((!sectionBg || sectionBg === "rgba(0, 0, 0, 0)" || sectionBg === "transparent") && section.dataset.background) {
			sectionBg = section.dataset.background;
		}
		if ((!sectionBg || sectionBg === "rgba(0, 0, 0, 0)" || sectionBg === "transparent") && section.dataset.bg) {
			sectionBg = section.dataset.bg;
		}
		return sectionBg && sectionBg !== "rgba(0, 0, 0, 0)" ? sectionBg : "transparent";
	}

	function adjustHeaderTheme(theme) {
		if (!header) return;
		if (theme === lastHeaderTheme) return;
		lastHeaderTheme = theme;
		if (theme == "light") {
			header.style.setProperty('--fg', 'var(--light)');
			header.style.setProperty('--hfg', 'var(--dark)');
		} else if (theme == "dark") {
			header.style.setProperty('--fg', 'var(--dark)');
			header.style.setProperty('--hfg', 'var(--light)');
		}
	}

	function updateHeaderOnScroll() {
		const scrollY = window.scrollY || window.pageYOffset;
		const bgThreshold = getBgScrollThreshold();
		const activeSection = getHeaderOverlapSection();
		const theme = activeSection ? activeSection.dataset.headerTheme : null;

		adjustHeaderTheme(theme);

		// Homepage hero: keep header transparent until scroll threshold; theme still follows overlap
		if (scrollY <= bgThreshold) {
			header.style.backgroundColor = "transparent";
		} else if (activeSection) {
			header.style.backgroundColor = getSectionBg(activeSection);
		} else {
			header.style.backgroundColor = "transparent";
		}
	}

	window.addEventListener('scroll', updateHeaderOnScroll, { passive: true });
	window.addEventListener('resize', updateHeaderOnScroll);
	document.addEventListener('DOMContentLoaded', updateHeaderOnScroll);
	
	// hero animation
	const homepageHero = document.querySelector(".banner");
	if (homepageHero != null) {
		let logo = homepageHero.querySelector(".banner-item");
		if (logo) {
			// Animate logo out on scroll down and back in on scroll up
			gsap.to(logo, {
				opacity: 0,
				// rotate: "-1deg",
				scrollTrigger: {
					trigger: homepageHero,
					start: "bottom" + homepageHero.offsetHeight,
					end: "bottom 20%",
					scrub: 0.1,
					pin: false,
					invalidateOnRefresh: true,
					toggleActions: "play none reverse none", // play on enter, reverse on leave back
				},
			});
		}
	}

});

/* Swiper Initialiser */
const swiperContainerP = document.getElementsByClassName('carousel_product')
for (var i = 0; i < swiperContainerP.length; i++) {
	swiperContainerP[i].classList.add('swiperP' + i)

	const swiperPage = swiperContainerP[i].querySelector('.swiper-pagination')

	if (swiperPage) {
		swiperPage.classList.add('pageP' + i)
	}

	var mySwiperP = new Swiper('.swiperP' + i, {
		direction: 'horizontal',
		loop: false,
		autoHeight: false,
		slidesPerView: 1,
		speed: 300,
		centeredSlides: true,
		pagination: {
			el: '.pageP' + i,
			clickable: true,
		},
	})
}

/* Open Cart */

if (window.location.hash === '#cart') {
	document.body.classList.add('js-my-cart-open');
}

const cartModalCloseBtn = document.querySelector('.cart-modal__close-btn');
if (cartModalCloseBtn) {
	cartModalCloseBtn.addEventListener('click', () => {
	// INSERT_YOUR_CODE
	if (window.location.hash === '#cart') {
		history.replaceState(null, '', window.location.pathname + window.location.search);
	}
	});
}

const detailLinks = document.querySelectorAll('details a')

detailLinks.forEach((link) => {
	link.addEventListener('click', (e) => {
		e.stopPropagation()
	})
})

/* Details Animator */
const details = document.querySelectorAll('details')

if (details) {
	details.forEach((targetDetail) => {
		targetDetail.addEventListener('click', function (e) {
			if (targetDetail.hasAttribute('open')) {
				e.preventDefault()
				targetDetail.classList.add('closing')
				setTimeout(() => {
					targetDetail.removeAttribute('open')
					targetDetail.classList.remove('closing')
				}, 390)
			}
		})
	})
}

/* Orphan Remove and LSEP Removal */
// var nbspSelectors = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'a', 'span']
// var nbspWordMin = 10 //Minimum words within parent tag to activate script

// nbspSelectors.forEach(function (selector) {
// 	var nbspElements = document.querySelectorAll(selector)
// 	nbspElements.forEach(function (element) {
// 		element.innerHTML = element.innerHTML.replace(/\u2028/g, '')
// 		element.innerHTML = element.innerHTML.replace(/&#8232;/g, '')
// 		var wordCount = element.innerHTML.split(' ').length
// 		if (wordCount >= nbspWordMin) {
// 			element.innerHTML = element.innerHTML.replace(/ ([^ ]*)$/, '&nbsp;$1')
// 		}
// 	})
// })

/* Lazy Load Initialiser */
var lazyLoadInstance = new LazyLoad({})

/* Liquid Ajax Cart */

liquidAjaxCart.subscribeToCartAjaxRequests((state, subscribeToResult) => {
	if (state.requestType == 'add') {
		const form = state.info.initiator
		let btnInner = ''

		const btn = form.querySelector('button[type="submit"]')
		if (btn) {
			btnInner = btn.innerHTML
			btn.innerHTML = 'ADDING'
		}

		subscribeToResult((state) => {
			const btn = form.querySelector('button[type="submit"]')
			if (state.responseData.ok) {
				cartOpen()
			}

			if (btn) {
				setTimeout(() => {
					btn.innerHTML = btnInner
				}, 300)
			}
		})
	}
})

/* enterview */
/* Load video on enter */

const llVideos = document.querySelectorAll('video.lazy')

if (llVideos.length > 0) {
	enterView({
		selector: '.video-ll',
		enter: function (el) {
			el.load()
			el.play()
		},
		offset: 0.1,
	})
}

// footer icon ticker 

window.addEventListener('DOMContentLoaded', () => {
	const wrappers = document.querySelectorAll(".footer-icons-track");
  
	wrappers.forEach((wrapper) => {
	  const items = Array.from(wrapper.querySelectorAll('.box'));
	  if (!items.length) return;
  
	  // Clean slate
	  wrapper.innerHTML = "";
  
	  // Utility: get gap value in px
	  function getGapPx() {
		if (window.innerWidth <= 768) return 50;
		let cssGap = getComputedStyle(document.documentElement).getPropertyValue('--Pxl').trim();
		if (!cssGap) cssGap = "20px";
		let numeric = parseInt(cssGap.replace("px", ""));
		return isNaN(numeric) ? 20 : numeric;
	  }
  
	  // Build track with enough clones to guarantee seamless loop
	  function buildInfiniteTrack(itemsArr) {
		// Create track
		const track = document.createElement('div');
		track.className = "pdp_img_track";
		track.style.display = "flex";
		track.style.flexWrap = "nowrap";
		track.style.alignItems = "center";
		track.style.height = "100%";
		track.style.willChange = "transform";
		track.style.minWidth = "0";
		track.style.gap = getGapPx() + "px";
		track.style.position = "relative";
		// Fill with items, and clone more if needed to fill for infinite wrap
		let logicalBoxes = [...itemsArr];
		let minRequiredBoxes = itemsArr.length;
		let totalWidth = 0;
		let minLoopWidth = window.innerWidth * 2;
		// At least loopable: repeat until track > window × 2 (covers wrap gap)
		while (totalWidth < minLoopWidth) {
		  itemsArr.forEach((item) => {
			let clone = item.cloneNode(true);
			track.appendChild(clone);
			logicalBoxes.push(clone);
		  });
		  // Update running width
		  // (We have to append first so offsetWidth is valid)
		  totalWidth = Array.from(track.children).reduce((acc, el, i, arr) => {
			// Add gap except on first
			return acc + el.offsetWidth + (i > 0 ? getGapPx() : 0);
		  }, 0);
		  minRequiredBoxes += itemsArr.length;
		}
		// Now append originals at the end, to ensure wrap covers all
		itemsArr.forEach((item) => {
		  let clone = item.cloneNode(true);
		  track.appendChild(clone);
		  logicalBoxes.push(clone);
		});
		// Now: append track to wrapper
		wrapper.appendChild(track);
		return {
		  track,
		  logicalBoxes: Array.from(track.children),
		  singleSet: itemsArr.length
		};
	  }
  
	  // Setup and animate infinite ticker
	  function infiniteLoop(itemsArr, wrapper) {
		let setup = buildInfiniteTrack(itemsArr);
  
		// Set flexShrink to avoid squish
		gsap.set(setup.logicalBoxes, { flexShrink: 0 });
  
		const gapPx = getGapPx();
		// Get total scrollable width (the distance needed for the seamless wrap)
		let totalSetWidth = setup.logicalBoxes.slice(0, -itemsArr.length).reduce((acc, el, idx) => {
		  // Don't count the final "wrap" set for total width, they only exist for seamless wrap
		  return acc + el.offsetWidth + (idx > 0 ? gapPx : 0);
		}, 0);
  
		// Actually the last set is for wrap, so the distance is totalSetWidth minus one set
		let scrollW = totalSetWidth;
  
		// Animate: forever loop by moving to -scrollW and then restarting at 0 instantly
		let speed = wrapper.dataset.speed || 50;
		speed = parseFloat(speed);
  
		let duration = scrollW / speed; // px/sec
  
		let tickerTl = gsap.timeline({ repeat: -1, defaults: { ease: "none" } });
		tickerTl.to(setup.track, { x: -scrollW, duration: duration })
		  .set(setup.track, { x: 0 });
  
		// On resize, completely rebuild
		function handleResize() {
		  if (tickerTl) tickerTl.kill();
		  wrapper.innerHTML = "";
		  loop = infiniteLoop(itemsArr, wrapper);
		}
		window.addEventListener('resize', () => {
		  // Debounce quickly
		  clearTimeout(wrapper._resizeTimeout);
		  wrapper._resizeTimeout = setTimeout(handleResize, 100);
		});
  
		// Add draggable if gsap/Draggable is available
		let draggable = null;
		if (typeof Draggable !== "undefined") {
		  const proxy = document.createElement("div");
		  let startX, startProgress;
		  draggable = Draggable.create(proxy, {
			trigger: wrapper,
			type: "x",
			onPressInit() {
			  tickerTl.pause();
			  startProgress = tickerTl.progress();
			  startX = this.x;
			},
			onDrag() {
			  const dx = this.x - startX;
			  // Update ticker progress
			  tickerTl.progress(gsap.utils.wrap(0, 1, startProgress - dx / scrollW));
			},
			onRelease() {
			  tickerTl.play();
			},
			inertia: true,
		  })[0];
		}
  
		// Auto scroll pause/play helpers (e.g., on hover)
		return {
		  play: () => tickerTl.play(),
		  pause: () => tickerTl.pause(),
		  setDuration: (d) => {
			tickerTl.duration(d);
		  },
		  draggable,
		  tickerTl,
		  duration,
		  scrollW
		};
	  }
  
	  // Create the infinite loop slider
	  let loop = infiniteLoop(items, wrapper);
  
	  // Helpers for pausing & speed
	  let autoScroll = { running: true };
	  let originalDuration = loop.duration;
	  const slowFactor = 4;
	  let isSlowed = false;
  
	  function startAutoScroll() {
		if (loop && !autoScroll.running) {
		  autoScroll.running = true;
		  loop.play();
		}
	  }
  
	  function stopAutoScroll() {
		if (loop && autoScroll.running) {
		  autoScroll.running = false;
		  loop.pause();
		}
	  }
  
	  function slowDown() {
		if (loop && loop.tickerTl && !isSlowed) {
		  isSlowed = true;
		  loop.setDuration(originalDuration * slowFactor);
		}
	  }
  
	  function restoreSpeed() {
		if (loop && loop.tickerTl && isSlowed) {
		  isSlowed = false;
		  loop.setDuration(originalDuration);
		}
	  }
  
	  // Attach hover handlers for speed
	  if (loop) {
		startAutoScroll();
		const hoverTarget = wrapper.querySelector('.pdp_img_track') || wrapper;
		hoverTarget.addEventListener('mouseenter', slowDown);
		hoverTarget.addEventListener('mouseleave', restoreSpeed);
  
		if (loop.draggable) {
		  loop.draggable.addEventListener("dragstart", stopAutoScroll);
		  loop.draggable.addEventListener("press", stopAutoScroll);
		  loop.draggable.addEventListener("release", () =>
			setTimeout(startAutoScroll, 500)
		  );
		  loop.draggable.addEventListener("throwcomplete", () =>
			setTimeout(startAutoScroll, 100)
		  );
		}
	  }
	});
  });
  
// menu selector
const menuSelectors = document.querySelectorAll('.menu-selector');
menuSelectors.forEach(selector => {
	selector.addEventListener('click', () => {
		document.querySelectorAll('.menu-selector').forEach(item => {
			item.classList.remove('active');
		});
		selector.classList.add('active');
		document.querySelectorAll('.menus-content-item').forEach(item => {
			item.classList.remove('active');
		});
		document.querySelector(`.menus-content-item[data-name="${selector.dataset.name}"]`).classList.add('active');
	});
});

// Set the background of the footer initial to the background colour of the last section on the page
document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('main section');
  const lastSection = sections[sections.length - 1];
  const footerInitial = document.querySelector('#shopify-section-footer-initial');
  if (lastSection && footerInitial) {
    const bgColor = window.getComputedStyle(lastSection).backgroundColor;
    if (bgColor) {
      footerInitial.style.backgroundColor = bgColor;
    }
  }
});

/* Swiper Initialiser */
const productCarousel = document.getElementsByClassName('product-carousel')
for (var i = 0; i < productCarousel.length; i++) {
	productCarousel[i].classList.add('productCarousel' + i)

	const nextButton = productCarousel[i].querySelector('.button-next');
	const prevButton = productCarousel[i].querySelector('.button-prev');

	if (nextButton) {
		nextButton.classList.add('button-next' + i)
	}
	if (prevButton) {
		prevButton.classList.add('button-prev' + i)
	}

	var mySwiperP = new Swiper('.productCarousel' + i, {
		direction: 'horizontal',
		loop: false,
		autoHeight: false,
		slidesPerView: 1,
		speed: 300,
		navigation: {
			nextEl: '.productCarousel' + i + ' .button-next',
			prevEl: '.productCarousel' + i + ' .button-prev',
		},
		breakpoints: {
			768: {
				slidesPerView: 4,
			},
		},
	})
}

function toggleSearch() {
  document.querySelector('.featured_collection-heading').classList.toggle('search-active');
}

function toggleFilters() {
  const heading = document.querySelector('.featured_collection-heading');
  const filters = document.querySelector('.filters');
  const filterItems = document.querySelectorAll('.filters .item');
  const isMobile = window.matchMedia('(max-width: 824px)').matches;

  heading.classList.toggle('filters-active');

  if (!isMobile) {
    // Desktop behavior (original)
    if (heading.classList.contains('filters-active')) {
      const tl = gsap.timeline({paused: true});
      tl.to(
        filters, {
          height: 'auto',
          duration: 0.4
        }
      ).to(filterItems, {
        opacity: 1,
        duration: 0.3,
        stagger: 0.05
      }, '<');
      tl.play();
    } else {
      const tl2 = gsap.timeline({paused: true});
      tl2.to(
        filters, {
          height: 0,
          duration: 0.4,
          ease: "ease"
        }
      ).to(filterItems, {
        opacity: 0,
        duration: 0.3,
      }, '<');
      tl2.play();
    }
  } else {
    // Mobile behavior: slide the modal, then animate the items
    if (heading.classList.contains('filters-active')) {
      // Ensure items are hidden, then show panel, then fade in items
      gsap.set(filterItems, {opacity: 0});
      gsap.to(filters, {
        x: '0%',
        duration: 0.5,
        ease: "power2.out",
        onStart: () => {
          filters.style.display = 'block'; // Ensure visible
        },
        onComplete: () => {
          gsap.to(filterItems, {
            opacity: 1,
            duration: 0.3,
            stagger: 0.05
          });
        }
      });
    } else {
      // Fade out items, then hide panel
      gsap.to(filterItems, {
        opacity: 0,
        duration: 0.2,
        onComplete: () => {
          gsap.to(filters, {
            x: '105%',
            duration: 0.5,
            ease: "power2.in",
            onComplete: () => {
              filters.style.display = '';
            }
          });
        }
      });
    }
  }
}

// Product page
const pdp_details = document.querySelectorAll('.details');

// On load, set open items to proper height if they have 'open' class
pdp_details.forEach(detail => {
	const itemContent = detail.querySelector('.item-content');
	if (detail.classList.contains('open')) {
		gsap.set(itemContent, { height: 'auto' });
	} else {
		gsap.set(itemContent, { height: 0 });
	}
});

pdp_details.forEach(detail => {
	detail.addEventListener('click', (e) => {
		e.stopPropagation();
		const isOpen = detail.classList.contains('open');
		pdp_details.forEach(otherDetail => {
			const itemContent = otherDetail.querySelector('.item-content');
			if (otherDetail === detail) {
				if (isOpen) {
					// If already open, close it
					otherDetail.classList.remove('open');
					gsap.to(itemContent, {
						height: 0,
						duration: 0.3
					});
				} else {
					// If closed, open it
					otherDetail.classList.add('open');
					gsap.to(itemContent, {
						height: 'auto',
						duration: 0.3
					});
				}
			} else {
				otherDetail.classList.remove('open');
				gsap.to(itemContent, {
					height: 0,
					duration: 0.3
				});
			}
		});
	});
});

// Product page media wiper
if (document.querySelector('.pdpSwiper') && document.querySelector('.pdpSwiper2')) {
var swiper = new Swiper(".pdpSwiper", {
	spaceBetween: 10,
	slidesPerView: 'auto',
	freeMode: true,
	direction: 'vertical',
	// centeredSlides: true,
	watchSlidesProgress: true,
  });
  var swiper2 = new Swiper(".pdpSwiper2", {
	spaceBetween: 10,
	direction: 'vertical',
	navigation: {
	  nextEl: ".swiper-button-next",
	  prevEl: ".swiper-button-prev",
	},
	thumbs: {
		swiper: swiper,
		},
	});
}

// Create cursor element
window.addEventListener('load', () => {	
	const cursor = document.querySelector('.custom-cursor');

	// Track mouse position
	document.addEventListener('mousemove', e => {
		cursor.style.left = e.clientX + 'px';
		cursor.style.top = e.clientY + 'px';
	});
	// Apply hover effect only on .social-ticker items
	const socialTicker = document.querySelectorAll('.social-ticker-wrapper');
	if (socialTicker.length > 0)  {
		socialTicker.forEach(item => {
			item.addEventListener('mouseenter', () => {
				cursor.innerHTML = item.dataset.ig;
				cursor.classList.add('active');
			});
			item.addEventListener('mouseleave', () => {
				cursor.classList.remove('active');
			});
		});
	}
});

// media swiper 
const mediaSwiper = document.querySelectorAll('.media-swiper');
for (var i = 0; i < mediaSwiper.length; i++) {

	mediaSwiper[i].classList.add('media-swiper-' + i);
	var mySwiper = new Swiper('.media-swiper-' + i, {
		direction: 'horizontal',
		loop: false,
		slidesPerView: 1,
		speed: 600,
		autoplay: {
			delay: 5000,
			disableOnInteraction: false,
		},
		pagination: {
			el: '.media-swiper-' + i + ' .swiper-pagination',
			clickable: true,
		},
	});
}

// mobile
// toggle menu
const menuToggle = document.querySelector('.menu-toggle');
// const mobileMenu = document.querySelector('.mobile-menu');
const header = document.querySelector('#shopify-section-header');
// header.classList.toggle('active');
menuToggle.addEventListener('click', () => {
	header.classList.toggle('active');
});

// For all nav-item-expand buttons, toggle the .open class on their parent .nav-item on click
document.querySelectorAll('.nav-item-expand').forEach(btn => {
	btn.addEventListener('click', function (e) {
		e.preventDefault();
		const parent = btn.closest('.nav-item');
		if (parent) {
			parent.classList.toggle('open');
		// INSERT_YOUR_CODE
		const content = parent.querySelector('.nav-item-content');
		if (content) {
			if (parent.classList.contains('open')) {
				gsap.to(content, { height: 'auto', duration: 0.4, overwrite: true });
			} else {
				gsap.to(content, { height: 0, duration: 0.4, overwrite: true });
			}
		}
		}
	});
});

// mobile menus
const mobileMenus = document.querySelectorAll('.menus-content-buttons_button');

// Open the first menu and its drop by default on page load
if (mobileMenus.length > 0) {
	const firstMenu = mobileMenus[0];
	const firstParent = firstMenu.parentElement;
	const firstDrop = firstParent.querySelector('.menus-content-buttons_drop');
	firstParent.classList.add('active');
	if (firstDrop) {
		// Immediately set height to auto to open it, skip transition on load
		firstDrop.style.height = 'auto';
	}
}

mobileMenus.forEach(menu => {
	menu.addEventListener('click', () => {
		const theParent = menu.parentElement;
		theParent.classList.toggle('active');

		const drop = theParent.querySelector('.menus-content-buttons_drop');
		const allHolders = document.querySelectorAll('.menu-content-holder');
		if (theParent.classList.contains('active')) {
			// Close all other drops
			allHolders.forEach(holder => {
				if (holder !== theParent) {
					holder.classList.remove('active');
					const otherDrop = holder.querySelector('.menus-content-buttons_drop');
					if (otherDrop) {
						gsap.to(otherDrop, { height: 0, duration: 0.4, overwrite: true });
					}
				}
			});
			// Open this drop
			if (drop) {
				gsap.to(drop, { height: 'auto', duration: 0.4, overwrite: true });
			}
		} else {
			// Close this drop
			if (drop) {
				gsap.to(drop, { height: 0, duration: 0.4, overwrite: true });
			}
		}
	});
});